import { MatExpansionPanelDefaultOptions } from "@angular/material/expansion";

export const expansionPanelDefaultOptions: MatExpansionPanelDefaultOptions = {
  expandedHeight: "3.6rem",
  collapsedHeight: "3.6rem",
  hideToggle: false
};
